import React from "react";
import * as ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./auth/AuthContext";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";

import { ThemeProvider } from "@mui/material/styles";
import theme from "./utils/theme";

// QueryClientProvider sits above AuthProvider because the auth listener needs
// `useQueryClient` to clear the cache on sign-out — without that, the next user
// to sign in would see the previous user's cached data.
//
// Dropping redux-persist leaves its `persist:root` key behind in every existing
// user's browser, as the removed subscriptions cache leaves `subscriptions_cache`.
// Clear both once on boot rather than leaving stale payloads in storage forever.
try {
  localStorage.removeItem("persist:root");
  localStorage.removeItem("subscriptions_cache");
} catch {
  // Storage can be unavailable (private mode, blocked cookies); nothing here is
  // load-bearing, so a failure to tidy up must not stop the app booting.
}
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
);
